import { BaseErrorCode } from './codes';

export class BaseError extends Error {
  public readonly code: BaseErrorCode;
  public readonly detailCode?: string;
  public readonly details?: unknown;

  constructor(message: string, code: BaseErrorCode, detailCode?: string, details?: unknown) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    if (detailCode !== undefined) {
      this.detailCode = detailCode;
    }
    if (details !== undefined) {
      this.details = details; // Optional structured data about the error
    }

    // Maintain proper stack trace in runtimes that support V8's API
    const ErrorWithOptionalCapture: ErrorConstructor & {
      captureStackTrace?: (target: object) => void;
    } = Error;
    if (ErrorWithOptionalCapture.captureStackTrace) {
      ErrorWithOptionalCapture.captureStackTrace(this);
    }
  }
}
